import { AfterContentInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApplicationContextService, ILookUpType, RolePermissionService } from 'lib-core-shared';
import { ComponentBaseDirective } from '../../directives/component.directive';


@Component({
  selector: 'lib-address-details',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.css']
})
export class AddressComponent extends ComponentBaseDirective implements OnInit, AfterContentInit {
  @Input() public formGroup: FormGroup = {} as FormGroup;
  @Input() public allowAddressNameField: boolean = true;
  @Input() public defaultCountry!: ILookUpType;
  @Output() public formGroupEmitter = new EventEmitter<FormGroup>();
  @Output() public isContactNumberVerified = new EventEmitter<boolean>();
  @Input() public parentFormSubmitted: boolean = false;
  contactNumberVerified?: boolean;
  showContactNumber: boolean = false; 
  @Input() contactNumberRequired?: boolean;

  constructor(
    public roleService: RolePermissionService,
    public activatedRoute: ActivatedRoute,
    public applicationContext: ApplicationContextService,
    public router: Router,) {
      super(activatedRoute, router, roleService, applicationContext);
     }
  ngAfterContentInit(): void {
    this.formGroup.valueChanges.subscribe(x => this.formGroupEmitter.emit(this.formGroup));
  }

  ngOnInit(): void {
  }

  numberUpdated(e: any, formControl: AbstractControl) {
    formControl.setValue(e.number);
    console.log('number updated, ' + JSON.stringify(e))
  }

  checkIsVerified(e: any, type: string) {

    console.log(e)

    this.contactNumberVerified = e;
    this.isContactNumberVerified.emit(e);

  }

  isValidPhoneNumberProvided(): boolean {
    return this.contactNumberVerified ? true : false
  }
}
